import { InjectionToken } from '@angular/core';
import { ScanCloudConfig } from '../model/scan-cloud.model';

export const SCAN_CONFIG = new InjectionToken<ScanCloudConfig>('SCAN_CONFIG');
